// extracted by css-extract-rspack-plugin
export default {"form":"kBJ5d_AJ8FkdcpHM__form___","filterSection":"VSAjAM_JDwd5x0n8__filterSection___"};